// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage, defineMessages, WrappedComponentProps, injectIntl } from "react-intl";

import { IState } from "states/states";
import { IAction, ActionType, raiseAction } from "actions";
import { toDropdownItems } from "guiutils";

import Dropdown from "view/comp/Dropdown";

interface ITrendMemberSelectExtProps {
  className?: string;
  showOnlyPower?: boolean;
}

interface ITrendMemberSelectProps {
  trendmember: "energy" | "power" | "costs";
}

const mapStateToProps = (state: IState) => {
  const props: ITrendMemberSelectProps = {
    trendmember: state.gui.trendMember,
  };
  return props;
};

interface ITrendMemberSelectDispatch {
  onDropdownChanged: (name: string, value: string | number) => void;
}

const mapDispatchToProps = (
  dispatch: (action: IAction<any>) => void,
  ownProps: ITrendMemberSelectExtProps,
) => {
  const dispatchProps: ITrendMemberSelectDispatch = {
    onDropdownChanged: (name: string, value: string | number) => {
      dispatch(
        raiseAction(ActionType.ACT_EDIT_VALUE, {
          name,
          value,
        }),
      );
    },
  };
  return dispatchProps;
};

const messages = defineMessages({
  selectCaption: {
    id: "Select data",
  },
});

class TrendMemberSelectComponent extends React.Component<
  ITrendMemberSelectProps &
    ITrendMemberSelectExtProps &
    ITrendMemberSelectDispatch &
    WrappedComponentProps
> {
  public render() {
    const availTrendMembers = ["costs", "energy", "power"];
    if (this.props.showOnlyPower === true) {
      availTrendMembers.splice(0, 2);
    }
    const trendmemberItems = toDropdownItems(
      availTrendMembers,
      "trendMember",
      this.props.onDropdownChanged,
      (value) => <FormattedMessage id={`TrendMember_${value}`} />,
    );

    return (
      <div id="trendmemberselect" className={this.props.className}>
        <Dropdown
          items={trendmemberItems}
          caption={this.props.intl.formatMessage(messages.selectCaption)}
          curItem={this.props.intl.formatMessage({ id: `TrendMember_${this.props.trendmember}` })}
        />
      </div>
    );
  }
}

const TrendMemberSelect = connect(mapStateToProps, mapDispatchToProps)(TrendMemberSelectComponent);

export default injectIntl(TrendMemberSelect);
